import type { FaireProductEntity } from "../../entity_types/product";

export const p_5t5677brug: FaireProductEntity = {
  token: "p_5t5677brug",
  type: "product",
  name: "LIBBY - Platform Thong Heels, Woven Texture",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/7d04dc5f0bf64b6643db7f91603d65c497310347af87acc9c78aba6d8aaac154.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b09eb9e71955fc2a5cfc2f0c154f30b68132c4ff37749cf2c7e8d9cd2682cbee.jpeg",
    "https://cdn.faire.com/fastly/ebbaedede577e8575e335aa3a79f435a2ebd162c123b8114c65628d072afada4.jpeg",
    "https://cdn.faire.com/fastly/b769e2795f2307be4a69c80ed558cb51f6240898c0144669410fc327e27edfb7.jpeg",
    "https://cdn.faire.com/fastly/4cc069b7885c234490704dbae6ddb813529e262c15810727144c781d44bd89a7.jpeg",
  ],
  priceDollars: 13,
  description:
    "Step up your warm-weather wardrobe with these statement platform flip flops, featuring a bold oversized bow and a textured wrapped platform sole. Designed to add height without sacrificing comfort, they're the perfect mix of playful and elevated. Available in metallic gold, beige, chocolate, and black.\nOOTD\nPair them with a breezy linen set, a flowy maxi dress, or relaxed denim shorts and a fitted tank for an effortlessly chic summer look. Finish with layered gold jewelry and an oversized tote for an outfit that's ready for brunch, vacation, or sunset strolls.\n",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:08.059Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
